import React from 'react';
import { Navigate } from 'react-router-dom';
import { authService } from '../../services/authService';

/**
 * AdminRoute - Restricts access to admin-only routes.
 * Checks if the current user's role is one of the allowed admin roles.
 * Redirects non-admin users to /dashboard.
 */
const ADMIN_ROLES = ['super_admin', 'System Admin', 'admin'];

const AdminRoute = ({ children }) => {
  const user = authService.getUser();

  if (!user) {
    return <Navigate to="/signin" replace />;
  }

  const userRole = user.role || '';
  const isAdmin = ADMIN_ROLES.includes(userRole);

  if (!isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default AdminRoute;
